module.exports = __webpack_public_path__ + "img/imag1.e000550f.png";